module.exports = __webpack_public_path__ + "static/img/tiktok-icon-detail.60465c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/tiktok-icon-detail.png
// module id = xiPq
// module chunks = 46